import type { DetectionResponse, InpaintingResponse, RecoloringResponse } from "@/types/AutoFixResponse";
import { defineStore } from "pinia";

interface AutofixState {
    detectionsResponse: DetectionResponse | null,
    inpaintingResponse: InpaintingResponse | null,
    outpaintingResponse: string | null,
    recoloringResponse: RecoloringResponse | null,
    isAutofixHappening: boolean,
    autofixColors: string[]
}

export const useAutofixStore = defineStore('autofix', {
    state: (): AutofixState => ({
        detectionsResponse: null,
        inpaintingResponse: null,
        outpaintingResponse: null,
        recoloringResponse: null,
        isAutofixHappening: false,
        autofixColors: ['#000000', '#ffffff']
    }),
    actions: {
        resetAutofixState() {
            this.detectionsResponse = null
            this.inpaintingResponse = null
            this.outpaintingResponse = null
            this.recoloringResponse = null
            this.isAutofixHappening = false
            this.autofixColors = ['#000000', '#ffffff']
        }
    }
})